import { APIHandler } from "../apiHandler";

class NBConvertHandler extends APIHandler {
  async get() {
    // This request just needs to exist to squelch network related errors.
    const response = {};
    this.finish(response);
  }
}

export const defaultHandlers: [string, typeof APIHandler][] = [
  ["/api/nbconvert", NBConvertHandler],
];
